import { useRouter, } from 'next/router';

export default function useTagId() {
  const router = useRouter();

  return router.query.tagId;
}
